import { iD3Data, iData } from "../types";

export const deleteD3SimplePath = ({
    d3Data,
    relatedTo,
    data,
    setData
}: {
    d3Data: iD3Data;
    relatedTo: string;
    data: iData;
    setData: React.Dispatch<React.SetStateAction<iData>>;
    }): iData =>
{
    const newDataRels = data.relLinks.map((rl) => {
        if (rl._id === relatedTo) {
            delete rl.simplePath;
        }

        return rl;
    });

    const newNodeRelationships = data.nodeRelationships.map((nr) => {
        if (nr._id === relatedTo) {
            delete nr.simplePath;
        }

        return nr;
    });

    const newDataObjects = data.objects.map((item) => {
        item.simplePath = item.simplePath.filter((sp) => {
            if (sp.relatedTo === relatedTo) {
                return false;
            }

            return true;
        });

        return item;
    });

    const newData = {
        ...data,
        objects: newDataObjects,
        relLinks: newDataRels,
        nodeRelationships: newNodeRelationships
    };

    setData(newData);
    return newData;
};

export const deleteD3SimplePathCreate = ({
    d3Data,
    relatedTo,
    data,
    setData
}: {
    d3Data: iD3Data;
    relatedTo: string;
    data: iData;
    setData: React.Dispatch<React.SetStateAction<iData>>;
}): iData => {
    const newDataRels = data.relLinks.map((rl) => {
        if (rl._id === relatedTo) {
            delete rl.simplePathCreate;
        }

        return rl;
    });

    const newNodeRelationships = data.nodeRelationships.map((nr) => {
        if (nr._id === relatedTo) {
            delete nr.simplePathCreate;
        }

        return nr;
    });

    const newDataObjects = data.objects.map((item) => {
        item.simplePathCreate = item.simplePathCreate.filter((sp) => {
            if (sp.relatedTo === relatedTo) {
                return false;
            }

            return true;
        });

        return item;
    });

    const newData = {
        ...data,
        objects: newDataObjects,
        relLinks: newDataRels,
        nodeRelationships: newNodeRelationships
    };

    setData(newData);
    return newData;
};

export const deleteD3SimplePathRead = ({
    d3Data,
    relatedTo,
    data,
    setData
}: {
    d3Data: iD3Data;
    relatedTo: string;
    data: iData;
    setData: React.Dispatch<React.SetStateAction<iData>>;
}): iData => {
    const newDataRels = data.relLinks.map((rl) => {
        if (rl._id === relatedTo) {
            delete rl.simplePathRead;
        }

        return rl;
    });

    const newNodeRelationships = data.nodeRelationships.map((nr) => {
        if (nr._id === relatedTo) {
            delete nr.simplePathRead;
        }

        return nr;
    });

    const newDataObjects = data.objects.map((item) => {
        item.simplePathRead = item.simplePathRead.filter((sp) => {
            if (sp.relatedTo === relatedTo) {
                return false;
            }

            return true;
        });

        return item;
    });

    const newData = {
        ...data,
        objects: newDataObjects,
        relLinks: newDataRels,
        nodeRelationships: newNodeRelationships
    };

    setData(newData);
    return newData;
};

export const deleteD3SimplePathUpdate = ({
    d3Data,
    relatedTo,
    data,
    setData
}: {
    d3Data: iD3Data;
    relatedTo: string;
    data: iData;
    setData: React.Dispatch<React.SetStateAction<iData>>;
}): iData => {
    const newDataRels = data.relLinks.map((rl) => {
        if (rl._id === relatedTo) {
            delete rl.simplePathUpdate;
        }

        return rl;
    });

    const newNodeRelationships = data.nodeRelationships.map((nr) => {
        if (nr._id === relatedTo) {
            delete nr.simplePathUpdate;
        }

        return nr;
    });

    const newDataObjects = data.objects.map((item) => {
        item.simplePathUpdate = item.simplePathUpdate.filter((sp) => {
            if (sp.relatedTo === relatedTo) {
                return false;
            }

            return true;
        });

        return item;
    });

    const newData = {
        ...data,
        objects: newDataObjects,
        relLinks: newDataRels,
        nodeRelationships: newNodeRelationships
    };

    setData(newData);
    return newData;
};

export const deleteD3SimplePathDelete = ({
    d3Data,
    relatedTo,
    data,
    setData
}: {
    d3Data: iD3Data;
    relatedTo: string;
    data: iData;
    setData: React.Dispatch<React.SetStateAction<iData>>;
}): iData => {
    const newDataRels = data.relLinks.map((rl) => {
        if (rl._id === relatedTo) {
            delete rl.simplePathDelete;
        }

        return rl;
    });

    const newNodeRelationships = data.nodeRelationships.map((nr) => {
        if (nr._id === relatedTo) {
            delete nr.simplePathDelete;
        }

        return nr;
    });

    const newDataObjects = data.objects.map((item) => {
        item.simplePathDelete = item.simplePathDelete.filter((sp) => {
            if (sp.relatedTo === relatedTo) {
                return false;
            }

            return true;
        });

        return item;
    });

    const newData = {
        ...data,
        objects: newDataObjects,
        relLinks: newDataRels,
        nodeRelationships: newNodeRelationships
    };

    setData(newData);
    return newData;
};
